import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import Tabs from './Tabs';
import TabsCardContent from './TabsCardContent';
import TabsContent from './TabsContent';
import { TabsWrapperProps } from './types';
/* -------------------------------------------------------------------------- */
/*                               Tabs Wrapper                              */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* To use this component create the following in your main component          */
/* 
  const initalActiveTab = 1; //or set it from state
  const tabs = [
    { icon: "User", title: "profile.generalData", tabId: 1 },
    { icon: "Lock", title: "profile.changePassword", tabId: 2 },
    { icon: "Map", title: "profile.mapOptions", tabId: 3 },
  ];
  const tabsContent = [
    { tabId: 1, component: <GeneralTabContent /> },
    { tabId: 2, component: <PasswordTabContent /> },
    {
      tabId: 3,
      component: <MapOptionsTabContent />,
    },
  ];
  Tabs is a list of the tabs you want to render
  Initial active tab
  Vertical if you wants tabs to be shown vertical, false if you want them horizontal                           
                                                                              */
/* -------------------------------------------------------------------------- */

const TabsWrapper = ({
  vertical = false,
  initialActiveTab = 1,
  tabs,
  tabsContent = null,
  className = '',
  useCardContent = true,
  activeTab = null, //If you need control of activeTab outside the component
  setActiveTab = null, //If you need control of activeTab outside the component
  checkbox = false,
  useIntl = true,
  align = 'left',
  fullHeight = false
}: TabsWrapperProps) => {
  if (activeTab == null || setActiveTab == null)
    [activeTab, setActiveTab] = useState(initialActiveTab);
  useEffect(() => {
    setActiveTab(initialActiveTab);
  }, [initialActiveTab]);
  return (
    <>
      {vertical ? (
        <Row className={className}>
          <Col className="mb-2 mb-md-0" md="3">
            <Tabs
              activeTab={activeTab}
              toggleTab={setActiveTab}
              tabs={tabs}
              align={align}
              vertical={vertical}
              checkbox={checkbox}
              useIntl={useIntl}
            />
          </Col>
          <Col md="9">
            {useCardContent ? (
              <TabsCardContent activeTab={activeTab} tabsContent={tabsContent} />
            ) : (
              <TabsContent activeTab={activeTab} tabsContent={tabsContent} />
            )}
          </Col>
        </Row>
      ) : fullHeight ? (
        <div
          className={className}
          style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}
        >
          <div style={{ flexShrink: 0 }}>
            <Tabs
              activeTab={activeTab}
              toggleTab={setActiveTab}
              tabs={tabs}
              align={align}
              vertical={vertical}
              checkbox={checkbox}
              useIntl={useIntl}
            />
          </div>
          {useCardContent ? (
            <TabsCardContent activeTab={activeTab} tabsContent={tabsContent} />
          ) : (
            <TabsContent activeTab={activeTab} tabsContent={tabsContent} fullHeight />
          )}
        </div>
      ) : (
        <Row className={className}>
          <Col sm="12" style={{ padding: '0px' }}>
            <Tabs
              activeTab={activeTab}
              toggleTab={setActiveTab}
              tabs={tabs}
              align={align}
              vertical={vertical}
              checkbox={checkbox}
              useIntl={useIntl}
            />
            {useCardContent ? (
              <TabsCardContent activeTab={activeTab} tabsContent={tabsContent} />
            ) : (
              <TabsContent activeTab={activeTab} tabsContent={tabsContent} />
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default TabsWrapper;
